module.exports = __webpack_public_path__ + "img/custom.24f6a3c1.png";